import {
  type AllocationUpdateEventMessage,
  type TradingEventMessage,
  TradingEventMessageType,
} from '@/types/api/events/trading-event'

export function getLatestAllocationUpdate(
  tradingEvents: TradingEventMessage[] | undefined | null,
): AllocationUpdateEventMessage | null {
  if (!tradingEvents?.length) return null

  // Events are in chronological order; iterate backwards to find latest allocation_update
  for (let i = tradingEvents.length - 1; i >= 0; i--) {
    if (
      // biome-ignore lint/style/noNonNullAssertion: suppress noUncheckedIndexedAccess
      tradingEvents[i]!.msg_type === TradingEventMessageType.AllocationUpdate
    ) {
      return tradingEvents[i] as AllocationUpdateEventMessage
    }
  }
  return null
}
